import { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import { api, type Connection, type Platform } from '../api/client'
import { useWorkspaceContext } from '../hooks/useWorkspaceContext'
import Tabs from '../components/Tabs'
import PasswordInput from '../components/PasswordInput'

const TABS = [
  { id: 'connected', label: 'Connected Accounts' },
  { id: 'available', label: 'Connect New' },
]

const PLATFORM_SVG: Record<string, string> = {
  'X/Twitter': '<svg viewBox="0 0 24 24" width="24" height="24"><path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/></svg>',
  'XTwitter': '<svg viewBox="0 0 24 24" width="24" height="24"><path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/></svg>',
  'LinkedIn Personal': '<svg viewBox="0 0 24 24" width="24" height="24"><path fill="#0A66C2" d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 01-2.063-2.065 2.064 2.064 0 112.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/></svg>',
  'LinkedIn Org': '<svg viewBox="0 0 24 24" width="24" height="24"><path fill="#0A66C2" d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 01-2.063-2.065 2.064 2.064 0 112.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/></svg>',
  'LinkedIn Ads': '<svg viewBox="0 0 24 24" width="24" height="24"><path fill="#0A66C2" d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 01-2.063-2.065 2.064 2.064 0 112.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/></svg>',
  'Instagram': '<svg viewBox="0 0 24 24" width="24" height="24"><defs><radialGradient id="ig" cx="30%" cy="107%" r="150%"><stop offset="0%" stop-color="#fdf497"/><stop offset="5%" stop-color="#fdf497"/><stop offset="45%" stop-color="#fd5949"/><stop offset="60%" stop-color="#d6249f"/><stop offset="90%" stop-color="#285AEB"/></radialGradient></defs><path fill="url(#ig)" d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z"/></svg>',
  'Facebook': '<svg viewBox="0 0 24 24" width="24" height="24"><path fill="#1877F2" d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/></svg>',
  'Threads': '<svg viewBox="0 0 24 24" width="24" height="24"><path d="M12.186 24h-.007c-3.581-.024-6.334-1.205-8.184-3.509C2.35 18.44 1.5 15.586 1.472 12.01v-.017c.03-3.579.879-6.43 2.525-8.482C5.845 1.205 8.6.024 12.18 0h.014c2.746.02 5.043.725 6.826 2.098 1.677 1.29 2.858 3.13 3.509 5.467l-2.04.569c-1.104-3.96-3.898-5.984-8.304-6.015-2.91.022-5.11.936-6.54 2.717C4.307 6.504 3.616 8.914 3.589 12c.027 3.086.718 5.496 2.057 7.164 1.43 1.783 3.631 2.698 6.54 2.717 2.623-.02 4.358-.631 5.8-2.045 1.647-1.613 1.618-3.593 1.09-4.798-.31-.71-.873-1.3-1.634-1.75-.192 1.352-.622 2.446-1.284 3.272-.886 1.102-2.14 1.704-3.73 1.79-1.202.065-2.361-.218-3.259-.801-1.063-.689-1.685-1.74-1.752-2.96-.065-1.19.408-2.285 1.33-3.082.88-.762 2.083-1.196 3.58-1.291l.058-.004c1.054-.052 2.012.016 2.881.194-.094-.614-.326-1.108-.694-1.477-.525-.527-1.322-.796-2.37-.808h-.03c-.876 0-1.97.267-2.573 1.14l-1.71-1.14c.923-1.39 2.453-2.12 4.283-2.12h.05c1.603.019 2.87.545 3.767 1.563.737.836 1.17 1.928 1.297 3.27.39.148.762.322 1.117.522 1.178.664 2.094 1.6 2.653 2.709.818 1.625.904 4.356-1.188 6.41-1.792 1.762-4.084 2.53-7.208 2.554zM12.35 14.1h-.05c-1.573.092-2.594.78-2.556 1.473.019.357.238.68.615.908.465.283 1.098.43 1.783.392 1.093-.059 3.056-.592 3.29-3.66-.756-.145-1.575-.212-2.403-.174l-.68.06z"/></svg>',
  'Bluesky': '<svg viewBox="0 0 600 530" width="24" height="24"><path fill="#0085ff" d="m135.72 44.03c66.496 49.921 138.02 151.14 164.28 205.46 26.262-54.316 97.782-155.54 164.28-205.46 47.98-36.021 125.72-63.892 125.72 24.795 0 17.712-10.155 148.79-16.111 170.07-20.703 73.984-96.144 92.854-163.25 81.433 117.3 19.964 147.14 86.092 82.697 152.22-122.39 125.59-175.91-31.511-189.63-71.766-2.514-7.3796-3.6904-10.832-3.7077-7.8964-0.0174-2.9357-1.1937 0.51684-3.7077 7.8964-13.714 40.255-67.233 197.36-189.63 71.766-64.444-66.128-34.605-132.26 82.697-152.22-67.108 11.421-142.55-7.4491-163.25-81.433-5.9562-21.282-16.111-152.36-16.111-170.07 0-88.687 77.742-60.816 125.72-24.795z"/></svg>',
  'YouTube': '<svg viewBox="0 0 24 24" width="24" height="24"><path fill="#FF0000" d="M23.498 6.186a3.016 3.016 0 00-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 00.502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 002.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 002.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/></svg>',
  'TikTok': '<svg viewBox="0 0 24 24" width="24" height="24"><path d="M12.525.02c1.31-.02 2.61-.01 3.91-.02.08 1.53.63 3.09 1.75 4.17 1.12 1.11 2.7 1.62 4.24 1.79v4.03c-1.44-.05-2.89-.35-4.2-.97-.57-.26-1.1-.59-1.62-.93-.01 2.92.01 5.84-.02 8.75-.08 1.4-.54 2.79-1.35 3.94-1.31 1.92-3.58 3.17-5.91 3.21-1.43.08-2.86-.31-4.08-1.03-2.02-1.19-3.44-3.37-3.65-5.71-.02-.5-.03-1-.01-1.49.18-1.9 1.12-3.72 2.58-4.96 1.66-1.44 3.98-2.13 6.15-1.72.02 1.48-.04 2.96-.04 4.44-.99-.32-2.15-.23-3.02.37-.63.41-1.11 1.04-1.36 1.75-.21.51-.15 1.07-.14 1.61.24 1.64 1.82 3.02 3.5 2.87 1.12-.01 2.19-.66 2.77-1.61.19-.33.4-.67.41-1.06.1-1.79.06-3.57.07-5.36.01-4.03-.01-8.05.02-12.07z"/></svg>',
  'Google Business': '<svg viewBox="0 0 24 24" width="24" height="24"><path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92a5.06 5.06 0 01-2.2 3.32v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.1z"/><path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/><path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/><path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/></svg>',
  'Google Ads': '<svg viewBox="0 0 24 24" width="24" height="24"><path fill="#FBBC04" d="M3.2 14.6L8.4 5.8c.7-1.2 2.3-1.6 3.5-.9s1.6 2.3.9 3.5L7.6 17.2c-.7 1.2-2.3 1.6-3.5.9s-1.6-2.3-.9-3.5z"/><path fill="#4285F4" d="M14.4 14.6l5.2-8.8c.7-1.2 2.3-1.6 3.5-.9s1.6 2.3.9 3.5l-5.2 8.8c-.7 1.2-2.3 1.6-3.5.9s-1.6-2.3-.9-3.5z"/><circle fill="#34A853" cx="6" cy="18" r="3"/></svg>',
  'GA4': '<svg viewBox="0 0 24 24" width="24" height="24"><path fill="#F9AB00" d="M12 2L2 19.5h20L12 2zm0 4l6.9 11.9H5.1L12 6z"/><circle fill="#E37400" cx="12" cy="16" r="2"/></svg>',
  'Meta': '<svg viewBox="0 0 24 24" width="24" height="24"><path fill="#0081FB" d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/></svg>',
  'Pinterest': '<svg viewBox="0 0 24 24" width="24" height="24"><path fill="#E60023" d="M12.017 0C5.396 0 .029 5.367.029 11.987c0 5.079 3.158 9.417 7.618 11.162-.105-.949-.199-2.403.041-3.439.219-.937 1.406-5.957 1.406-5.957s-.359-.72-.359-1.781c0-1.668.967-2.914 2.171-2.914 1.023 0 1.518.769 1.518 1.69 0 1.029-.655 2.568-.994 3.995-.283 1.194.599 2.169 1.777 2.169 2.133 0 3.772-2.249 3.772-5.495 0-2.873-2.064-4.882-5.012-4.882-3.414 0-5.418 2.561-5.418 5.207 0 1.031.397 2.138.893 2.738a.36.36 0 01.083.345l-.333 1.36c-.053.22-.174.267-.402.161-1.499-.698-2.436-2.889-2.436-4.649 0-3.785 2.75-7.262 7.929-7.262 4.163 0 7.398 2.967 7.398 6.931 0 4.136-2.607 7.464-6.227 7.464-1.216 0-2.359-.631-2.75-1.378l-.748 2.853c-.271 1.043-1.002 2.35-1.492 3.146C9.57 23.812 10.763 24 12.017 24c6.624 0 11.99-5.367 11.99-11.988C24.007 5.367 18.641 0 12.017 0z"/></svg>',
  'Telegram': '<svg viewBox="0 0 24 24" width="24" height="24"><path fill="#26A5E4" d="M11.944 0A12 12 0 000 12a12 12 0 0012 12 12 12 0 0012-12A12 12 0 0012 0h-.056zm5.521 7.11l-1.855 8.744c-.14.625-.505.78-.99.495l-2.805-2.07-1.36 1.31c-.15.15-.278.278-.57.278l.202-2.862 5.213-4.712c.228-.202-.05-.315-.35-.113L8.398 12.56l-2.765-.865c-.6-.188-.615-.6.125-.89l10.8-4.163c.5-.18.94.12.775.89l.132-.422z"/></svg>',
  'Discord': '<svg viewBox="0 0 24 24" width="24" height="24"><path fill="#5865F2" d="M20.317 4.492c-1.53-.69-3.17-1.2-4.885-1.49a.075.075 0 00-.079.036c-.21.369-.444.85-.608 1.23a18.566 18.566 0 00-5.487 0 12.36 12.36 0 00-.617-1.23A.077.077 0 008.562 3c-1.714.29-3.354.8-4.885 1.491a.07.07 0 00-.032.027C.533 9.093-.32 13.555.099 17.961a.08.08 0 00.031.055 20.03 20.03 0 005.993 2.98.078.078 0 00.084-.026c.462-.62.874-1.275 1.226-1.963.021-.04.001-.088-.041-.104a13.201 13.201 0 01-1.872-.878.075.075 0 01-.008-.125c.126-.093.252-.19.372-.287a.075.075 0 01.078-.01c3.927 1.764 8.18 1.764 12.061 0a.075.075 0 01.079.009c.12.098.245.195.372.288a.075.075 0 01-.006.125c-.598.344-1.22.635-1.873.877a.075.075 0 00-.041.105c.36.687.772 1.341 1.225 1.962a.077.077 0 00.084.028 19.963 19.963 0 006.002-2.981.076.076 0 00.032-.054c.5-5.094-.838-9.52-3.549-13.442a.06.06 0 00-.031-.028zM8.02 15.278c-1.182 0-2.157-1.069-2.157-2.38 0-1.312.956-2.38 2.157-2.38 1.21 0 2.176 1.077 2.157 2.38 0 1.312-.956 2.38-2.157 2.38zm7.975 0c-1.183 0-2.157-1.069-2.157-2.38 0-1.312.955-2.38 2.157-2.38 1.21 0 2.176 1.077 2.157 2.38 0 1.312-.946 2.38-2.157 2.38z"/></svg>',
}

const DIRECT_AUTH_PLATFORMS = ['Bluesky', 'Telegram', 'Discord']

const SANDBOX_ALLOWED_PLATFORMS = [
  'Facebook', 'Instagram', 'Threads', 'YouTube',
  'LinkedIn Personal', 'LinkedIn Org', 'LinkedIn Ads',
  'Google Business', 'Google Ads',
  'TikTok', 'TikTok Ads',
  'Pinterest',
]

const NEEDS_ACCOUNT_SELECTION = ['ga4', 'google ads', 'linkedin ads', 'youtube', 'google business']
const isPendingAccount = (conn: Connection) =>
  conn.platformAccountID?.startsWith('pending-') ||
  conn.platformAccountID === 'pending'

interface DiscoverableAccount {
  accountId: string
  displayName: string
  description: string
}

const HOWTO_TELEGRAM = `**Screenshots will be added here.**

---

### Step 1: Create a Bot via BotFather

1. Open Telegram and search for **@BotFather** (verified blue tick)
2. Send \`/newbot\`
3. Follow the prompts:
   - Enter a **display name** (e.g. "Acme Updates")
   - Enter a **username** (must end in \`bot\`, e.g. \`acme_updates_bot\`)
4. BotFather replies with your **bot token** -- copy it. It looks like: \`7891234567:AAF1xxxxxxxxxxxxxxxxxxxxxxxxxxx\`
5. (Optional) Customise the bot:
   - \`/setdescription\` -- what users see when they open the bot
   - \`/setabouttext\` -- short bio
   - \`/setuserpic\` -- upload your brand logo

### Step 2: Add the Bot to Your Channel or Group

1. Open your Telegram channel or group
2. Go to **Settings > Administrators** (channel) or **Add Members** (group)
3. Search for your bot username (e.g. \`@acme_updates_bot\`)
4. Add it as an **Administrator** with at least these permissions:
   - Post messages
   - Edit messages of others
   - Delete messages
5. Note the **Chat ID**:
   - For channels: use the channel's \`@username\` (e.g. \`@acme_channel\`) or numeric ID
   - For groups: the numeric ID (starts with \`-100...\`)
   - To find the numeric ID: forward a message from the channel to \`@userinfobot\`

### Step 3: Connect in the Platform

1. Enter the **Channel / Group** (\`@username\` or numeric ID) in the form
2. Enter the **Bot Token** from BotFather
3. Click **Connect**
4. The platform validates the token and displays the channel name
5. The webhook registers automatically -- no manual configuration needed
`

const HOWTO_DISCORD = `**Screenshots will be added here.**

---

### What You Need

The Discord bot is already set up by your platform admin. You just need to add it to your server and connect.

### Step 1: Invite the Bot to Your Server

If the bot isn't already in your server, ask your admin for the invite link, or look for an "Add to Server" link after connecting below. You'll need **Manage Server** permission in Discord to add it.

### Step 2: Find Your Server ID

1. Open Discord
2. Go to **User Settings** (gear icon) > **Advanced**
3. Turn on **Developer Mode**
4. Go back to your server list
5. **Right-click** your server name in the left sidebar
6. Click **Copy Server ID**

### Step 3: Connect

1. Paste your **Server (Guild) ID** in the form
2. Click **Connect**
3. The platform uses the pre-configured bot token to validate access
4. If the bot isn't in your server yet, you'll see an invite link -- click it to add the bot

### Troubleshooting

- **"Cannot access server"** -- The bot hasn't been invited yet. Use the invite link shown in the error.
- **"Bot token not configured"** -- Your admin needs to set up the Discord bot token in Admin Settings > API Keys.
`

function DirectAuthPanel({
  platform, handle, password, connecting,
  onHandleChange, onPasswordChange, onConnect, onCancel,
}: {
  platform: Platform
  handle: string
  password: string
  connecting: boolean
  onHandleChange: (v: string) => void
  onPasswordChange: (v: string) => void
  onConnect: () => void
  onCancel: () => void
}) {
  const [subTab, setSubTab] = useState<'connect' | 'howto'>('connect')
  const isTelegram = platform.name === 'Telegram'
  const isDiscord = platform.name === 'Discord'
  const isBotPlatform = isTelegram || isDiscord

  const handleLabel = isTelegram ? 'Channel / Group' : isDiscord ? 'Server (Guild) ID' : 'Handle'
  const handlePlaceholder = isTelegram
    ? '@yourchannel or chat ID'
    : isDiscord
      ? 'Right-click server > Copy Server ID (enable Developer Mode first)'
      : 'e.g. yourhandle.bsky.social'
  const passwordLabel = isTelegram ? 'Bot Token' : 'App Password'
  const passwordPlaceholder = isTelegram
    ? 'e.g. 123456:ABCdef...'
    : 'Generate at bsky.app/settings/app-passwords'
  const hint = isTelegram
    ? 'Telegram uses bot tokens. Create a bot via @BotFather and enter the token + channel username.'
    : isDiscord
      ? 'Enter your Discord Server ID below. The bot token is pulled from Admin Settings automatically.'
      : `${platform.name} uses direct authentication (handle + app password), not OAuth.`

  return (
    <div className="smm-card" style={{ marginBottom: '1rem', maxWidth: 640 }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <h3 style={{ margin: 0 }}>Connect {platform.name}</h3>
        {isBotPlatform && (
          <div style={{ display: 'flex', gap: 0 }}>
            <button
              className={`smm-btn smm-btn-sm ${subTab === 'connect' ? 'smm-btn-primary' : ''}`}
              style={{ borderRadius: '6px 0 0 6px' }}
              onClick={() => setSubTab('connect')}>
              Connect
            </button>
            <button
              className={`smm-btn smm-btn-sm ${subTab === 'howto' ? 'smm-btn-primary' : ''}`}
              style={{ borderRadius: '0 6px 6px 0' }}
              onClick={() => setSubTab('howto')}>
              How To
            </button>
          </div>
        )}
      </div>

      {subTab === 'connect' && (
        <>
          <p className="smm-hint" style={{ marginTop: '0.5rem' }}>{hint}</p>
          <div style={{ display: 'grid', gap: '0.75rem', marginTop: '0.75rem' }}>
            <div className="smm-bio-field">
              <label>{handleLabel}</label>
              <input className="smm-input" value={handle} onChange={e => onHandleChange(e.target.value)}
                placeholder={handlePlaceholder} />
            </div>
            {!isDiscord && (
              <div className="smm-bio-field">
                <label>{passwordLabel}</label>
                <PasswordInput value={password} onChange={e => onPasswordChange(e.target.value)}
                  placeholder={passwordPlaceholder} />
              </div>
            )}
            <div style={{ display: 'flex', gap: '0.5rem' }}>
              <button className="smm-btn smm-btn-primary" onClick={onConnect}
                disabled={!handle.trim() || (!isDiscord && !password.trim()) || connecting}>
                {connecting ? 'Connecting...' : 'Connect'}
              </button>
              <button className="smm-btn" onClick={onCancel}>Cancel</button>
            </div>
          </div>
        </>
      )}

      {subTab === 'howto' && (
        <div style={{ marginTop: '0.75rem', fontSize: '0.9rem', lineHeight: 1.65, maxHeight: 480, overflowY: 'auto', padding: '0 0.25rem' }}>
          {(isTelegram ? HOWTO_TELEGRAM : HOWTO_DISCORD).split('\n').map((line, i) => {
            if (line.startsWith('### ')) return <h4 key={i} style={{ margin: '1.25rem 0 0.5rem', borderBottom: '1px solid var(--smm-border)', paddingBottom: '0.25rem' }}>{line.replace('### ', '')}</h4>
            if (line.startsWith('**Screenshots')) return <div key={i} style={{ padding: '0.5rem 0.75rem', background: '#fff3e0', borderRadius: 6, marginBottom: '0.5rem', fontStyle: 'italic', fontSize: '0.85em' }}>{line.replace(/\*\*/g, '')}</div>
            if (line === '---') return <hr key={i} style={{ border: 'none', borderTop: '1px solid var(--smm-border)', margin: '0.5rem 0' }} />
            if (line.trim() === '') return <div key={i} style={{ height: 4 }} />
            const formatted = line
              .replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>')
              .replace(/\[(.+?)\]\((.+?)\)/g, '<a href="$2" target="_blank" rel="noopener noreferrer">$1</a>')
              .replace(/`(.+?)`/g, '<code style="background:#f0f0f0;padding:0.1em 0.3em;border-radius:3px;font-size:0.9em">$1</code>')
            return <div key={i} dangerouslySetInnerHTML={{ __html: formatted }} style={{ marginLeft: line.match(/^\d+\./) ? '1rem' : line.startsWith('   -') ? '2rem' : 0 }} />
          })}
        </div>
      )}
    </div>
  )
}

export default function Connections() {
  const { activeWorkspace } = useWorkspaceContext()
  const wsId = activeWorkspace?.workspaceID ?? 0
  const location = useLocation()
  const [tab, setTab] = useState('connected')
  const [connections, setConnections] = useState<Connection[]>([])
  const [platforms, setPlatforms] = useState<Platform[]>([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)
  const [connectingPlatform, setConnectingPlatform] = useState<string | null>(null)
  const [directAuthPlatform, setDirectAuthPlatform] = useState<Platform | null>(null)
  const [directHandle, setDirectHandle] = useState('')
  const [directPassword, setDirectPassword] = useState('')
  const [discoverConn, setDiscoverConn] = useState<Connection | null>(null)
  const [discoverAccounts, setDiscoverAccounts] = useState<DiscoverableAccount[]>([])
  const [discoverLoading, setDiscoverLoading] = useState(false)
  const [discoverError, setDiscoverError] = useState<string | null>(null)
  const [manualAccountId, setManualAccountId] = useState('')

  useEffect(() => {
    setLoading(true)
    Promise.all([
      api.get<Connection[]>(`/workspaces/${wsId}/connections`),
      api.get<Platform[]>(`/workspaces/${wsId}/connections/platforms`),
    ])
      .then(([conns, plats]) => { setConnections(conns); setPlatforms(plats) })
      .catch(err => setError(err instanceof Error ? err.message : 'Failed to load connections'))
      .finally(() => setLoading(false))
  }, [wsId])

  useEffect(() => {
    const params = new URLSearchParams(location.search)
    const oauthResult = params.get('oauth_result')
    const oauthError = params.get('oauth_error')
    const oauthPlatform = params.get('platform')
    const reconnectPlatform = params.get('reconnect')

    if (oauthResult === 'success') {
      window.history.replaceState({}, '', window.location.pathname)
      setTab('connected')
      api.get<Connection[]>(`/workspaces/${wsId}/connections`)
        .then(setConnections)
        .catch(err => console.error('[SMM] Failed to refresh connections after OAuth', err))
    } else if (oauthError) {
      setError(`OAuth failed${oauthPlatform ? ` for ${oauthPlatform}` : ''}: ${decodeURIComponent(oauthError)}`)
      window.history.replaceState({}, '', window.location.pathname)
    } else if (reconnectPlatform && platforms.length > 0) {
      window.history.replaceState({}, '', window.location.pathname)
      const match = platforms.find(p =>
        p.name.toLowerCase() === reconnectPlatform.toLowerCase())
      if (match) {
        handleConnect(match)
      } else {
        setError(`Platform "${reconnectPlatform}" not found. Connect manually from the list below.`)
        setTab('available')
      }
    }
  }, [location.search, wsId, platforms.length])

  const handleConnect = async (platform: Platform) => {
    if (DIRECT_AUTH_PLATFORMS.includes(platform.name)) {
      setDirectAuthPlatform(platform)
      setDirectHandle('')
      setDirectPassword('')
      return
    }
    try {
      setConnectingPlatform(platform.name)
      const returnUrl = `${window.location.origin}${window.location.pathname}`

      const response = await api.get<{ authorizeUrl: string; state: string }>(
        `/workspaces/${wsId}/connections/oauth/authorize?platform=${encodeURIComponent(platform.name)}&redirectUri=${encodeURIComponent(returnUrl)}`
      )

      window.location.href = response.authorizeUrl
    } catch (err) {
      const msg = err instanceof Error ? err.message : 'Failed to initiate OAuth'
      setError(`Connection failed: ${msg}. Make sure API keys are configured in Admin Settings.`)
      setConnectingPlatform(null)
    }
  }

  const handleDirectAuth = async () => {
    if (!directAuthPlatform || !directHandle.trim()) return
    const isDiscordConnect = directAuthPlatform.name === 'Discord'
    if (!isDiscordConnect && !directPassword.trim()) return
    try {
      setConnectingPlatform(directAuthPlatform.name)
      const result = await api.post<{ connectionId?: number; webhook?: string }>(`/workspaces/${wsId}/connections/direct-auth`, {
        platform: directAuthPlatform.name,
        platformID: directAuthPlatform.platformID,
        handle: directHandle.trim(),
        appPassword: isDiscordConnect ? 'from-admin-settings' : directPassword.trim(),
      })
      setDirectAuthPlatform(null)
      const conns = await api.get<Connection[]>(`/workspaces/${wsId}/connections`)
      setConnections(conns)
      setTab('connected')
      if (result && typeof result === 'object' && result.webhook) {
        setError(result.webhook)
        setTimeout(() => setError(null), 8000)
      }
    } catch (err) {
      const msg = err instanceof Error ? err.message : 'Direct auth failed'
      setError(`Connection failed: ${msg}`)
    } finally {
      setConnectingPlatform(null)
    }
  }

  const handleDisconnect = async (connId: number) => {
    if (!confirm('Disconnect this account?')) return
    try {
      await api.del(`/workspaces/${wsId}/connections/${connId}`)
      setConnections(prev => prev.filter(c => c.connectionID !== connId))
    } catch (err) {
      console.error('[SMM] Disconnect failed', err)
    }
  }

  const handleTogglePause = async (conn: Connection) => {
    try {
      if (conn.isPaused) {
        await api.post(`/workspaces/${wsId}/connections/${conn.connectionID}/resume`)
      } else {
        await api.post(`/workspaces/${wsId}/connections/${conn.connectionID}/pause`, { isPaused: true })
      }
      setConnections(prev => prev.map(c => c.connectionID === conn.connectionID ? { ...c, isPaused: !c.isPaused } : c))
    } catch (err) {
      console.error('[SMM] Pause toggle failed', err)
    }
  }

  const handleDiscoverAccounts = async (conn: Connection) => {
    setDiscoverConn(conn)
    setDiscoverAccounts([])
    setDiscoverError(null)
    setDiscoverLoading(true)
    setManualAccountId('')
    try {
      const accounts = await api.get<DiscoverableAccount[]>(
        `/workspaces/${wsId}/connections/${conn.connectionID}/discover-accounts`
      )
      setDiscoverAccounts(accounts)
    } catch (err) {
      setDiscoverError(err instanceof Error ? err.message : 'Discovery failed')
    } finally {
      setDiscoverLoading(false)
    }
  }

  const handleSelectAccount = async (accountId: string, displayName: string) => {
    if (!discoverConn) return
    try {
      await api.put(`/workspaces/${wsId}/connections/${discoverConn.connectionID}/select-account`, {
        accountId, displayName,
      })
      setConnections(prev => prev.map(c =>
        c.connectionID === discoverConn.connectionID
          ? { ...c, platformAccountID: accountId, displayName }
          : c
      ))
      setDiscoverConn(null)
    } catch (err) {
      setDiscoverError(err instanceof Error ? err.message : 'Selection failed')
    }
  }

  if (loading) return <div className="smm-loading">Loading connections...</div>

  const activeConns = connections.filter(c => c.isActive)
  const pausedConns = connections.filter(c => c.isPaused)

  return (
    <div className="smm-connections">
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <h1>Connected Accounts</h1>
      </div>
      {error && <div className="smm-error">{error}<button className="smm-btn smm-btn-sm" style={{ marginLeft: '1rem' }} onClick={() => setError(null)}>Dismiss</button></div>}
      {connectingPlatform && (
        <div className="smm-card" style={{ textAlign: 'center', padding: '1.5rem', background: 'var(--smm-accent-bg, #eef)' }}>
          Connecting to <strong>{connectingPlatform}</strong>... Please wait.
        </div>
      )}
      <Tabs tabs={TABS} activeTab={tab} onTabChange={setTab} />

      {tab === 'connected' && (
        <>
          {activeConns.length === 0 ? (
            <div className="smm-card" style={{ textAlign: 'center', padding: '2rem' }}>
              <p style={{ fontSize: '1.1rem' }}>No accounts connected yet.</p>
              <p className="smm-hint">Connect a social media platform to start publishing and tracking.</p>
              <button className="smm-btn smm-btn-primary" onClick={() => setTab('available')} style={{ marginTop: '1rem' }}>Connect a Platform</button>
            </div>
          ) : (
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))', gap: '1rem' }}>
              {activeConns.map(conn => {
                const pending = isPendingAccount(conn)
                const isExpired = !pending && conn.tokenExpiresAt && new Date(conn.tokenExpiresAt) < new Date()
                const hasError = !pending && !!conn.lastTokenError
                const needsReconnect = isExpired || hasError
                const borderColor = pending ? '#e67e22' : needsReconnect ? '#d32f2f' : conn.isPaused ? '#f39c12' : '#27ae60'
                return (
                  <div key={conn.connectionID} className="smm-card"
                    style={{ borderLeft: `4px solid ${borderColor}` }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                      <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                        {conn.profileImageUrl ? (
                          <img src={conn.profileImageUrl} alt="" style={{ width: 36, height: 36, borderRadius: '50%', objectFit: 'cover', flexShrink: 0 }}
                            onError={e => { (e.target as HTMLImageElement).style.display = 'none' }} />
                        ) : (
                          <span style={{ width: 36, height: 36, borderRadius: '50%', background: '#e8e8e8', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, fontSize: '0.85rem', color: '#888', fontWeight: 600 }}>
                            {conn.platformName?.charAt(0) || '?'}
                          </span>
                        )}
                        <div>
                          <strong>{conn.displayName}</strong>
                          <div><span className="smm-badge">{conn.platformName}</span></div>
                        </div>
                      </div>
                      {pending && <span className="smm-badge" style={{ background: '#e67e22', color: '#fff' }}>Setup needed</span>}
                      {!pending && needsReconnect && <span className="smm-badge" style={{ background: '#d32f2f', color: '#fff' }}>Expired</span>}
                      {!pending && !needsReconnect && conn.isPaused && <span className="smm-badge" style={{ background: '#f39c12', color: '#fff' }}>Paused</span>}
                    </div>
                    {pending ? (
                      <div style={{ margin: '0.75rem 0', padding: '0.75rem', background: '#fff3e0', borderRadius: '6px' }}>
                        <p style={{ margin: 0, fontSize: '0.85rem' }}>
                          Select which account/property to use with this connection.
                        </p>
                        <button className="smm-btn smm-btn-primary smm-btn-sm" style={{ marginTop: '0.5rem' }}
                          onClick={() => handleDiscoverAccounts(conn)}>
                          Choose Account
                        </button>
                      </div>
                    ) : (
                      <div style={{ margin: '0.75rem 0' }}>
                        <div style={{ fontSize: '1.5rem', fontWeight: 700 }}>{conn.followerCount.toLocaleString()}</div>
                        <div className="smm-hint">{conn.platformName === 'LinkedIn Personal' ? 'connections' : 'followers'}</div>
                      </div>
                    )}
                    <div className="smm-hint" style={{ marginBottom: '0.5rem' }}>
                      Connected {new Date(conn.connectedAt).toLocaleDateString()}
                      {conn.followerSyncedAt && <> | Synced {new Date(conn.followerSyncedAt).toLocaleDateString()}</>}
                    </div>
                    {needsReconnect && (
                      <div style={{ margin: '0.5rem 0', padding: '0.5rem 0.75rem', background: '#ffebee', borderRadius: 6, fontSize: '0.82rem' }}>
                        <span style={{ color: '#c62828' }}>{conn.lastTokenError ? 'Refresh failed' : 'Token expired'}</span>
                        {' '}
                        <button
                          className="smm-btn smm-btn-sm smm-btn-primary"
                          style={{ marginLeft: 4 }}
                          onClick={() => {
                            const p = platforms.find(pl => pl.name === conn.platformName)
                            if (p) handleConnect(p)
                          }}>
                          Reconnect
                        </button>
                      </div>
                    )}
                    <div style={{ display: 'flex', gap: '0.5rem', flexWrap: 'wrap' }}>
                      {!pending && <button onClick={() => handleTogglePause(conn)} className="smm-btn smm-btn-sm">{conn.isPaused ? 'Resume' : 'Pause'}</button>}
                      {!pending && NEEDS_ACCOUNT_SELECTION.includes((conn.platformName ?? '').toLowerCase()) && (
                        <button onClick={() => handleDiscoverAccounts(conn)} className="smm-btn smm-btn-sm">Change Account</button>
                      )}
                      <button onClick={() => handleDisconnect(conn.connectionID)} className="smm-btn smm-btn-sm smm-btn-danger">Disconnect</button>
                    </div>
                  </div>
                )
              })}
            </div>
          )}
          {pausedConns.length > 0 && activeConns.length > 0 && (
            <p className="smm-hint" style={{ marginTop: '1rem' }}>{pausedConns.length} connection(s) currently paused.</p>
          )}
        </>
      )}

      {directAuthPlatform && (
        <DirectAuthPanel
          platform={directAuthPlatform}
          handle={directHandle}
          password={directPassword}
          connecting={connectingPlatform !== null}
          onHandleChange={setDirectHandle}
          onPasswordChange={setDirectPassword}
          onConnect={handleDirectAuth}
          onCancel={() => setDirectAuthPlatform(null)}
        />
      )}

      {tab === 'available' && (
        <div className="smm-card">
          <h3>Available Platforms</h3>
          <p className="smm-hint">Click a platform to begin the connection flow. API keys must be configured in Admin Settings first.</p>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))', gap: '1rem', marginTop: '1rem' }}>
            {platforms.filter(p => SANDBOX_ALLOWED_PLATFORMS.includes(p.name)).map(platform => (
              <button key={platform.platformID} className="smm-card"
                onClick={() => handleConnect(platform)}
                disabled={connectingPlatform !== null}
                style={{ cursor: connectingPlatform ? 'wait' : 'pointer', textAlign: 'center', padding: '1.5rem', border: '2px solid transparent', transition: 'border-color 0.2s' }}>
                <div style={{ width: '32px', height: '32px', margin: '0 auto 0.5rem' }}
                  dangerouslySetInnerHTML={{ __html: PLATFORM_SVG[platform.name] || '<svg viewBox="0 0 24 24" width="24" height="24"><circle cx="12" cy="12" r="10" fill="#ccc"/></svg>' }} />
                <strong>{platform.name}</strong>
                <div className="smm-hint" style={{ fontSize: '0.75rem', marginTop: '0.25rem' }}>
                  {[platform.supportsPublish && 'Publish', platform.supportsInbox && 'Inbox', platform.supportsAnalytics && 'Analytics', platform.supportsFollowerCount && 'Followers'].filter(Boolean).join(' | ')}
                </div>
              </button>
            ))}
          </div>
        </div>
      )}

      {discoverConn && (
        <div style={{
          position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)',
          display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000,
        }} onClick={() => setDiscoverConn(null)}>
          <div className="smm-card" style={{ minWidth: 400, maxWidth: 560, maxHeight: '80vh', overflowY: 'auto' }}
            onClick={e => e.stopPropagation()}>
            <h3>Select Account / Property</h3>
            <p className="smm-hint">
              Choose which {discoverConn.platformName} account to connect.
            </p>

            {discoverLoading && <p>Discovering available accounts...</p>}
            {discoverError && <div className="smm-error" style={{ marginBottom: '0.75rem' }}>{discoverError}</div>}

            {!discoverLoading && discoverAccounts.length > 0 && (
              <div style={{ display: 'grid', gap: '0.5rem', marginTop: '0.75rem' }}>
                {discoverAccounts.filter(a => a.accountId !== 'manual').map(acct => (
                  <button key={acct.accountId} className="smm-card"
                    onClick={() => handleSelectAccount(acct.accountId, acct.displayName)}
                    style={{ cursor: 'pointer', textAlign: 'left', padding: '0.75rem 1rem',
                      border: '2px solid transparent', transition: 'border-color 0.2s' }}>
                    <strong>{acct.displayName}</strong>
                    <div className="smm-hint" style={{ fontSize: '0.8rem' }}>{acct.description}</div>
                  </button>
                ))}
              </div>
            )}

            {!discoverLoading && (
              <div style={{ marginTop: '1rem', borderTop: '1px solid #eee', paddingTop: '0.75rem' }}>
                <p className="smm-hint" style={{ marginBottom: '0.5rem' }}>Or enter an ID manually:</p>
                <div style={{ display: 'flex', gap: '0.5rem' }}>
                  <input className="smm-input" style={{ flex: 1 }}
                    placeholder="Account / Property ID"
                    value={manualAccountId}
                    onChange={e => setManualAccountId(e.target.value)} />
                  <button className="smm-btn smm-btn-primary smm-btn-sm"
                    disabled={!manualAccountId.trim()}
                    onClick={() => handleSelectAccount(manualAccountId.trim(), `${discoverConn.platformName} - ${manualAccountId.trim()}`)}>
                    Use
                  </button>
                </div>
              </div>
            )}

            <div style={{ marginTop: '1rem', display: 'flex', justifyContent: 'flex-end' }}>
              <button className="smm-btn" onClick={() => setDiscoverConn(null)}>Cancel</button>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}
